import { defineStore } from 'pinia';

import type { INetworkedTenant } from '~/api/INetworkedTenant';

export const useStore = defineStore('RecipientStore', {
  state: () => ({
    recipient: [] as INetworkedTenant[],
  }),
  getters: {
    all: (state) => state.recipient,
  },
  actions: {
    update(recipient: INetworkedTenant[]) {
      this.recipient = recipient;
    },
  },
});
